/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import {
    CONTAINER_FIRSTNAME,
    CONTAINER_LASTNAME,
    CONTAINER_EMAIL,
    CONTAINER_PHONE,
    CONTAINER_COMPANY,
    CONTAINER_ZIPCODE,
    CONTAINER_CITY,
    CONTAINER_STREET,
    CONTAINER_HOUSE_NUMBER,
    CONTAINER_SUBMIT,
} from '../../../constant';
import { formValidation} from '@vfde-brix/core';
import {
    mountInputFieldRadioTitle,
    mountInputFieldFirstname,
    mountInputFieldLastname,
    mountInputFieldEmail,
    mountInputFieldPhone,
    mountInputFieldCompany,
    mountInputFieldZipcode,
    mountInputFieldCity,
    mountInputFieldStreet,
    mountInputFieldHouseNumber,
    mountCheckboxListHouse,
    mountCheckboxListCustomerType,
    mountCheckboxConfirmation,
} from '../../../components/InputField';
import { mountSubmitButton } from '../../../components/Button';

/**
 * Export createInputFieldContainer
 *
 */
const createInputFieldContainer = (containerId: string) => {
    const inputFieldContainer = document.getElementById(containerId);
    inputFieldContainer.innerHTML = '';

    return inputFieldContainer;
};

/**
 * Export mountRegistrationForm
 *
 * @export createRegistrationForm
 */
export const mountRegistrationForm = (action) => {
    /**
     * Title
     */
    const titleContainer = createInputFieldContainer('form-selection-control-title');
    const titleInputField = mountInputFieldRadioTitle(titleContainer, function (event: Event, value: string) {
        action.saveRegistrationData({title: value});
    });

    /**
     * Firstname
     */
    const firstnameContainer = createInputFieldContainer(CONTAINER_FIRSTNAME);
    const firstnameInputField = mountInputFieldFirstname(firstnameContainer, function (event: Event, value: string) {
        action.saveRegistrationData({firstname: value});
    });
    /**
     * Lastname
     */
    const lastnameContainer = createInputFieldContainer(CONTAINER_LASTNAME);
    const lastnameInputField = mountInputFieldLastname(lastnameContainer, function (event: Event, value: string) {
        action.saveRegistrationData({lastname: value});
    });
    /**
     * E-Mail
     */
    const emailContainer = createInputFieldContainer(CONTAINER_EMAIL);
    const emailInputField = mountInputFieldEmail(emailContainer, function (event: Event, value: string) {
        action.saveRegistrationData({email: value});
    });
    /**
     * Phone
     */
    const phoneContainer = createInputFieldContainer(CONTAINER_PHONE);
    const phoneInputField = mountInputFieldPhone(phoneContainer, function (event: Event, value: string) {
        action.saveRegistrationData({phone: value});
    });
    /**
     * Company
     */
    const companyContainer = createInputFieldContainer(CONTAINER_COMPANY);
    mountInputFieldCompany(companyContainer, function (event: Event, value: string) {
        action.saveRegistrationData({company: value});
    });
    /**
     * ZipCode
     */
    const zipCodeContainer = createInputFieldContainer(CONTAINER_ZIPCODE);
    const zipcodeInputField = mountInputFieldZipcode(zipCodeContainer, function (event: Event, value: string) {
        action.saveRegistrationData({zipcode: value});
    });
    /**
     * City
     */
    const cityContainer = createInputFieldContainer(CONTAINER_CITY);
    const cityInputField = mountInputFieldCity(cityContainer, function (event: Event, value: string) {
        action.saveRegistrationData({city: value});
    });
    /**
     * Street
     */
    const streetContainer = createInputFieldContainer(CONTAINER_STREET);
    const streetInputField = mountInputFieldStreet(streetContainer, function (event: Event, value: string) {
        action.saveRegistrationData({street: value});
    });
    /**
     * Hous number
     */
    const hnrContainer = createInputFieldContainer(CONTAINER_HOUSE_NUMBER);
    const hnrInputField = mountInputFieldHouseNumber(hnrContainer, function (event: Event, value: string) {
        action.saveRegistrationData({houseNumber: value});
    });
    /**
     * checkbox list house
     */
    const houseContainer = createInputFieldContainer('form-selection-control-house');
    const houseCheckboxList = mountCheckboxListHouse(houseContainer, function (event: Event, value: string) {
        const checkbox = event.target as HTMLInputElement;
        const data = {};
        data[value] = checkbox.checked;
        action.saveRegistrationData(data);
     });
    /**
     * checkbox list customerType
     */
    const customerTypeContainer = createInputFieldContainer('form-selection-control-customer');
    const customerTypeCheckboxList = mountCheckboxListCustomerType(customerTypeContainer, function (event: Event, value: string) {
        const checkbox = event.target as HTMLInputElement;
        const data = {};
        data[value] = checkbox.checked;
        action.saveRegistrationData(data);
    });
    /**
     * checkbox list Confirmation
     */
    const confirmationContainer  = createInputFieldContainer('brix-form-selection-control-confirmation');
    const confirmationText = (window as any).additionalPageOptions.confirmationText;
    const confirmationCheckboxList = mountCheckboxConfirmation(confirmationContainer, confirmationText, function (event: Event, value: string) {
        action.saveRegistrationData({ confirmation: ('confirmation' === value) ? true : false });
    });
    /**
     * submit BUTTON
     */
    const submitButtonContainer = createInputFieldContainer(CONTAINER_SUBMIT);
    const submitButtonText = (window as any).additionalPageOptions.submitButtonText;
    const submitButton = mountSubmitButton(submitButtonContainer, submitButtonText, function (event: Event, value: string) {
        action.sendRegistrationData();
    });

    /**
     * FormValidation
     */
    const formToValidate = {
        formFields: [
            titleInputField,
            firstnameInputField,
            lastnameInputField,
            emailInputField,
            phoneInputField,
            zipcodeInputField,
            cityInputField,
            streetInputField,
            hnrInputField,
            houseCheckboxList,
            customerTypeCheckboxList,
            confirmationCheckboxList,
        ],
        submitButton: submitButton,
        fieldsWithErrors: [],
    };

    /**
     * bind form validation
     */
    formValidation(formToValidate);
};
